import { StandardGrid, StandardGridPresentationType } from '@apply/components';
import { Column } from 'devextreme-react/data-grid';
import { IBridgeApplicationGridRecord } from '../../../mockData/mockApplicationsGridData';
import { actionCellRender } from './functions/renderers/actionCellRender';
import { userRender } from '../../../common/functions/renderers/userRender';
import { userEmailRender } from '../../../common/functions/renderers/userEmailRender';
import { pocRender } from '../../../common/functions/renderers/pocRender';
import { applicationCityRender } from '../../../common/functions/renderers/applicationCityRender';
import { applicationStateRender } from '../../../common/functions/renderers/applicationStateRender';

export interface IncompleteGridProps {
    data: IBridgeApplicationGridRecord[] | undefined;
}

export const IncompleteGrid = ({ data }: IncompleteGridProps) => {
    return (
        <>
            <StandardGrid
                dataSource={data}
                keyExpr='applicationId'
                presentationType={StandardGridPresentationType.Enhanced}
                noDataText='No Incomplete Applications Found'
                pagerVisible={false}
                rowAlternationEnabled={true}
                showColumnHeaders={true}
                remoteOperations={false}
            >
                <Column
                    dataField='borrower'
                    caption='Borrower'
                    alignment='left'
                />
                <Column
                    dataField='city'
                    caption='City'
                    width={250}
                    alignment='left'
                    cellRender={(e) => applicationCityRender(e)}
                />
                <Column
                    dataField='state'
                    caption='State'
                    width={120}
                    alignment='left'
                    cellRender={(e) => applicationStateRender(e)}
                />
                <Column
                    dataField='lastUpdated'
                    caption='Last Updated'
                    width={200}
                    alignment='left'
                    dataType='date'
                    format='M/dd/yyyy'
                />
                <Column
                    dataField='broker'
                    caption='Broker'
                    width={200}
                    alignment='left'
                />
                <Column
                    caption='User'
                    width={200}
                    alignment='left'
                    cellRender={(e) => userRender(e)}
                />
                <Column
                    dataField='userEmail'
                    caption='User Email'
                    width={350}
                    alignment='left'
                    cellRender={(e) => userEmailRender(e)}
                />
                <Column
                    dataField='poc'
                    caption='POC'
                    alignment='left'
                    width={100}
                    cellRender={(e) => pocRender(e)}
                />
                <Column
                    alignment='center'
                    cellRender={actionCellRender}
                    width={40}
                    allowReordering={false}
                    allowSorting={false}
                    allowResizing={false}
                    type='buttons'
                    fixed={true}
                    fixedPosition={'right'}
                />
            </StandardGrid>
        </>
    );
};
